<section class="managed-support-section" aria-labelledby="managed-support-heading">
  <div class="container">
    <p class="section-label text-center">Optional add-on</p>
    <h2 id="managed-support-heading" class="section-title">Want MemberTrace to do more of the work?</h2>
    <p class="section-subtitle">
      Add Managed Support to any plan. Software support is already included. Managed Support is hands-on help operating MemberTrace.
    </p>

    <div class="support-grid">
      <article class="support-card">
        <p class="support-eyebrow">Included with every plan</p>
        <h3>Included Support</h3>
        <p class="support-contrast">{{ includedContrast }}</p>
        <ul>
          <li *ngFor="let item of includedSupport">{{ item }}</li>
        </ul>
      </article>

      <article class="support-card support-card-featured">
        <p class="support-eyebrow">Optional for any plan</p>
        <h3>Managed Support</h3>
        <p class="support-contrast">{{ managedContrast }}</p>
        <ul>
          <li *ngFor="let item of managedSupport">{{ item }}</li>
        </ul>
        <p class="support-price">{{ managedPrice }}</p>
        <p class="support-note">
          Managed Support is a MemberTrace product add-on. It is not IT consulting, custom development, or a fractional CIO service.
        </p>
        <a mat-flat-button
           color="primary"
           routerLink="/contact"
           [queryParams]="{ inquiryType: 'managed-support' }"
           (click)="onManagedSupportCta()">
          Talk to us about Managed Support
        </a>
      </article>
    </div>
  </div>
</section>
